import { copyToClipboard } from '@/helpers/clipboard'
import { ContentCopy, CopyAll } from '@mui/icons-material'
import { ReactNode } from 'react'

interface CopyToClipboardProps {
  variant?: 'copy' | 'copy-all'
  value: string | number | ReactNode
}

export function CopyToClipboard({
  value,
  variant = 'copy',
}: CopyToClipboardProps) {
  return variant === 'copy' ? (
    <ContentCopy
      sx={{
        cursor: 'pointer',
        verticalAlign: 'text-top',
        ml: 1,
        fontSize: 16,
      }}
      onClick={() => copyToClipboard(value?.toString() ?? '')}
    />
  ) : (
    <CopyAll
      sx={{
        cursor: 'pointer',
        verticalAlign: 'text-top',
        ml: 1,
        fontSize: 18,
      }}
      onClick={() => copyToClipboard(value?.toString() ?? '')}
    />
  )
}
